export default {"src":"/_next/static/media/RACE.2bfe06ce.svg","height":18,"width":18};